export default function FloodPlaneChangesNotice() {
  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button className="accordion-button caret-off collapsed " type="button" data-bs-toggle="collapse" data-bs-target="#collapseFloodPlaneChangesNotice">
          <div className="custom-button-layout">
            <i className="fa-solid fa-house-flood-water fa-2xl feature-icon af-icon"></i>
            <b>NOTICE: Intent to revise the flood hazard information</b>
            <span className="badge bg-warning badge-custom">NOTICE</span>
          </div>
        </button>
      </h2>
      <div id="collapseFloodPlaneChangesNotice" className="accordion-collapse collapse" data-bs-parent="#latestNewsAccordion">
        <div className="accordion-body">
          <p>
            The Township of Falls and Borough of Morrisville Floodplain Administrators, in accordance with National Flood Insurance Program regulation 65.7(b)(1), hereby gives notice of the Township
            and Borough's intent to revise the flood hazard information, generally located along the Delaware River, West Channel, and Biles Creek. Specifically, the flood hazard information will be
            revised along Delaware River, West Channel, and Biles Creek from a point approximately halfway between the Lower Trenton Bridge and the Trenton-Morrisville Toll Bridge to a point
            approximately adjacent to the northbound exit ramp split from South Pennsylvania Ave for Tyburn Rd. As a result of the revision, the 1-percent annual-chance water-surface elevations shall
            increase and decrease, and the 1-percent-annual-chance floodplain will widen and narrow within the area of revision. Maps and detailed analysis of the revision can be reviewed at the Falls
            Township Municipal Building at 188 Lincoln Hwy #100, Fairless Hills, PA 19030. Interested persons may call the Township Floodplain Administrator of Falls Township at 188 Lincoln Hwy # 100,
            Fairless Hills, PA 19030 (per municipal calendar) for additional information from 8:00 to 4:30 Monday through Friday.{" "}
          </p>
           <a href="../docs/notice/notice-2026-floodplain-notice-july-13-2026-1.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp;Floodplain Notice
            </a>
        </div>
      </div>
    </div>
  );
}
